// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_k8-1";
export var quotedThread = "_k8-0";